import axios from 'axios';
import apiUrl from '../constants';

export function getshippingidDetails(input, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'disputeSummeryAPI',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}
export function getUserDetails(input, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'getHubEmpDetails',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}

export function getBagShipmentSummery(input, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'getBagShipmentSummery',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}


export function weightVarianceData(input, token){
  return axios({
    method: 'post',
    url: apiUrl.api_url + 'fetchWeightVarianceData',
    data: input,
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });
}
export function fetchingdeliverydateformanualdelivery(input, token){
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'fetchingdeliverydateformanualdelivery',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}


// WEBPACK FOOTER //
// ./src/services/getSummeryData.js